/**
 * De kleuren van Socrates, één keer, met een naam.
 *
 * Elke waarde hier stond eerder als losse hexcode in de schermen -- #70d1fa
 * zesenveertig keer. Nu heet die kleur `accent`, en wie "de blauwe knop" wil
 * veranderen, verandert één regel.
 *
 * De waarden zijn precies wat er stond; er is niets samengevoegd. Daardoor
 * zijn het er meer dan nodig: er zijn vier bijna gelijke grijzen voor lijnen
 * en vier voor vlakken. Ze staan bij elkaar, met de bedoeling ze op een rustig
 * moment terug te brengen tot één per rol. Dat is een kijk-beslissing, geen
 * code-beslissing, dus die is niet in de verhuizing meegenomen.
 */
export const kleur = {
  // de huisstijl
  accent: '#70d1fa',          // knoppen, actieve tab, badges, tijdklok
  accentLicht: '#e8f4f8',     // gekozen tegel, groepsbadge, actief lijstitem (leerkracht)
  accentLichter: '#e3f2fd',   // actief lijstitem (beheer), argumenten VOOR
  accentTekst: '#245',        // tekst op de lichte accentvlakken
  inkt: '#2c3e50',            // koppen en de stelling

  // tekst, van donker naar licht
  tekst: '#333',
  tekstZacht: '#555',
  tekstDonker: '#444',
  tekstGrijs: '#666',
  tekstStil: '#777',
  stil: '#7f8c8d',            // toelichtingen, subkoppen, placeholders
  stiller: '#95a5a6',         // lege staat, annuleerknop
  grijs: '#888',
  grijsLicht: '#bbb',

  // lijnen en vlakken
  lijn: '#e0e0e0',
  lijnZacht: '#ddd',
  lijnLichter: '#e4e4e4',
  lijnTegel: '#e8e8e8',
  lijnStippel: '#c0c0c0',
  lijnUit: '#ccc',
  vlak: '#f8f9fa',            // panelen, formulieren, lijstitems
  vlakKoel: '#f7f9fa',
  vlakWarm: '#fafafa',
  vlakGrijs: '#f0f0f0',
  vlakGrijsLicht: '#f5f5f5',
  vlakBron: '#f0f4f6',

  // betekenis: fout, waarschuwing, uitleg, correctie, groepsgenoot
  rood: '#e74c3c',
  roodDonker: '#c0392b',
  roodLicht: '#ffebee',
  oranje: '#f39c12',
  oranjeFel: '#ff9800',
  oranjeLicht: '#fff3e0',
  geel: '#ffc107',            // de uitleg-popup
  geelLicht: '#fff8e1',
  geelDonker: '#f57c00',
  amber: '#fff6e0',           // de taalcorrectie van Socrates
  amberLijn: '#f0d9a0',
  amberTekst: '#8a5a00',
  amberDonker: '#6b4c00',
  groen: '#27ae60',
  groenZacht: '#5a7',
  groenLicht: '#eef7ea',      // een bevestigde groepsgenoot
  groenTekst: '#2c4a22',
  paars: '#9b59b6',
  blauw: '#2980b9',
};
